import React from 'react';
import PropTypes from 'prop-types';

const StatefulButton = ({
  additionalClassName,
  name,
  onChange,
  primaryContent,
  secondaryContent,
  value,
}) => {
  const handleClick = () => onChange(name,
    !value);
  const classNames = [
    'stateful-button',
    additionalClassName,
  ];
  let content = '';
  if (value) {
    content = primaryContent;
    classNames.push('stateful-button--set');
  }
  else {
    content = secondaryContent || primaryContent;
  }
  return (
    <button
      className={classNames.join(' ')}
      onClick={handleClick}
    >
      {content}
    </button>
  );
};

StatefulButton.PropTypes = {
  additionalClassName:PropTypes.string,
  name:PropTypes.string.isRequired,
  onChange:PropTypes.func.isRequired,
  primaryContent:PropTypes.string.isRequired,
  secondaryContent:PropTypes.string,
  value:PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number,
    PropTypes.string,
  ]),
};

export default StatefulButton;
